import React from "react";
import {
  FaSearch,
  FaBullhorn,
  FaProjectDiagram,
} from "react-icons/fa";
import card2Bg from "../../../assets/Bulk/Card2/card2.svg";
import card3Bg from "../../../assets/Bulk/Card2/card3.svg";
import card1Bg from "../../../assets/Exactness/Header/Bg.svg";

const cardData = [
  {
     title: "Only Pay for Verified Emails - Guaranteed",
    description: "Only pay for fully verified emails with Exact Mails. We ensure you only invest in emails that meet the highest accuracy standards, giving you greater reliability for every outreach effort. Enjoy precision and cost-effectiveness with emails that are fully vetted, so every contact you make has real potential. No hidden costs or wasted credits—just verified results for seamless connections.",
    actionText: "Domain Search",
    icon: <FaSearch className="text-[#39C4DC] text-xl" />,
    bgImage: card1Bg,
    color: "text-[#39C4DC]",
    bgcolor: "bg-[#EBFBFC]",
    border: "border-[#99E1ED]"
  },
  {
    title: "Credits Usage",
    description: "We keep things simple: you only use one credit when you find a super-verified email—no matter if you search by name, domain, company, decision maker, or through our API or extension. Need more details? For an extra two credits, unlock a company’s corporate phone numbers and social links, adding even more value to your outreach!",
    actionText: "Campaigns",
    icon: <FaBullhorn className="text-[#F88DA0] text-xl" />,
    bgImage: card2Bg,
    color: "text-[#F88DA0]",
    bgcolor: "bg-[#FDEBED]",
    border: "border-[#F9AFBB]",
  },
  {
    title: "Unused Credits Carry Over",
    description: "Keep your subscription, and any unused credits will automatically roll over to the next month, so you always get the most out of your plan!",
    actionText: "Integrations",
    icon: <FaProjectDiagram className="text-[#64D1AE] text-xl" />,
    bgImage: card3Bg,
    color: "text-[#64D1AE]",
    bgcolor: "bg-[#EBFBF4]",
    border: "border-[#98E2C9]",
  },
  {
    title: "Duplicate Searches Are On Us",
    description: "With Exact Mails, duplicate searches are free—meaning if you’ve already searched for a contact, you won’t be charged for finding it again. This allows you to revisit results as often as you need without worrying about additional costs. cost-effective.",
    actionText: "Verifications",
    icon: <FaProjectDiagram className="text-[#cdd164] text-xl" />,
    bgImage: card1Bg,
    color: "text-[#d2d652]",
    bgcolor: "bg-yellow-100",
    border: "border-yellow-400",
  },
];

const TestimonialCards = () => {
  return (
    <>
    <div className="grid pt-10 lg:py-24 pb-10 gap-6 py-6 bg-gray-50 sm:grid-cols-2 2xl:grid-cols-4 p-6">
      {cardData.map((card, index) => (
        <div
          key={index}
          className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left "
          style={{
            backgroundImage: `url(${card.bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-white opacity-5"></div>
          <div className="relative z-10 flex flex-col h-full">
            <div
              className={`my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 ${card.border} border ${card.bgcolor}`}
            >
              <div className="my-4">{card.icon}</div>
            </div>
            <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
            <p className="text-gray-600 mb-4">{card.description}</p>
          </div>
        </div>
      ))}
    </div>
    </>
  );
};

export default TestimonialCards;
